<template>
  <div class="modal-content">
    <form @submit.prevent="saveRemarks">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Remakrs (Partners)</h5>
        <button
          ref="modalCloseBtn"
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="bi bi-x-circle"></i>
        </button>
      </div>
      <div class="modal-body">
        <div
          class="partner-modal-section"
          v-if="request.trip_request_route_remarks?.length > 0"
        >
          <div class="partner-modal-info">
            <h5 class="info-heading">
              Total Remarks
              <span class="item-count">{{
                request.trip_request_route_remarks.length
              }}</span>
            </h5>
            <div class="info-content fixed-height-info">
              <div
                v-for="(
                  routeRemark, index
                ) in request.trip_request_route_remarks"
                :key="index"
                class="info-row"
              >
                <p class="item-date">
                  {{ $format.date(routeRemark.created_at, 'DD/MM/YYYY') }}
                </p>
                <h5 class="item-title">
                  {{ routeRemark.remark }}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="partner-modal-info">
          <div class="info-content fixed-height-info">
            <div class="info-row">
              <h5 class="item-title">No Remarks Found!</h5>
            </div>
          </div>
        </div>
        <div
          class="partner-modal-section"
          v-if="$userPermission.has('vehicle-request-set-partner-remarks')"
        >
          <h5 class="section-heading">Add Instructions</h5>
          <div class="partner-form">
            <textarea
              class="form-control"
              v-model="formValue.remark"
              required
            ></textarea>
          </div>
        </div>
      </div>
      <div
        class="modal-footer no-border"
        v-if="$userPermission.has('vehicle-request-set-partner-remarks')"
      >
        <button
          type="button"
          class="btn btn-cancel"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Close
        </button>
        <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
        <button v-else class="btn btn-primary">Save Remark</button>
      </div>
    </form>
  </div>
</template>

<script>
import http from '../../../config/axios';

export default {
  props: ['request'],
  data() {
    return {
      isLoading: false,
      formValue: {
        remark: null
      }
    };
  },
  watch: {
    request() {
      this.emptyFormValue();
    }
  },
  methods: {
    emptyFormValue() {
      this.formValue.remark = null;
    },
    saveRemarks() {
      this.isLoading = true;
      let payloadData = {
        remarks_by_partner: [this.formValue.remark]
      };
      if (this.request.status === 'Requested') {
        payloadData.status = 'Reviewed';
      }

      http
        .patch(
          `v2/partners/triprequestroutes/${this.request.id}?trip_requests_id=${this.request.trip_requests_id}`,
          payloadData
        )
        .then((response) => {
          this.isLoading = false;
          this.emptyFormValue();
          this.$emit('refreshData');
          this.$refs.modalCloseBtn.click();
          this.$partnerSwal.quickSuccessAlert.fire({
            title: 'Success!',
            text: response.data?.message
          });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response.data?.message
          });
        });
    }
  }
};
</script>

<style scoped>
.partner-modal-info .info-row {
  padding: 12px 15px;
}
</style>
